// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.user-info-container {
  padding: 20px;
  background-color: #fff;
  border-radius: 12px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  font-family: "Arial", sans-serif;
  max-width: 90%;
  margin: auto;
  margin-top: 15px;
  overflow-x: auto;
}
.user-info-container .user-info-time {
  margin-bottom: 20px;
  font-size: 18px;
  color: #333;
  text-align: right;
}
@media (max-width: 768px) {
  .user-info-container .user-info-time {
    text-align: center;
    font-size: 16px;
  }
}
.user-info-container .user-info-table {
  width: 100%;
  border-collapse: collapse;
  border-radius: 12px;
  overflow: hidden;
  table-layout: auto;
}
.user-info-container .user-info-table th,
.user-info-container .user-info-table td {
  padding: 4px 6px;
  text-align: left;
  border: 1px solid #dcdcdc;
  background-color: #ffffff;
  transition: background-color 0.3s, color 0.3s;
}
.user-info-container .user-info-table th:first-child,
.user-info-container .user-info-table td:first-child {
  font-weight: bold;
  cursor: pointer;
  white-space: nowrap;
  min-width: 150px;
  text-overflow: ellipsis;
  overflow: hidden;
}
.user-info-container .user-info-table th:first-child:hover,
.user-info-container .user-info-table td:first-child:hover {
  background-color: var(--primary-color);
  color: #ffffff;
}
.user-info-container .user-info-table th {
  background-color: #e9e9e9;
  color: #333333;
  text-transform: uppercase;
  font-size: 16px;
  position: sticky;
  top: 0;
  z-index: 1;
}
.user-info-container .user-info-table th:hover {
  background-color: var(--primary-color);
  color: #ffffff;
}
.user-info-container .user-info-table th.user-info-selected-column {
  background-color: var(--primary-color);
  color: #ffffff;
}
.user-info-container .user-info-table tbody tr:nth-child(even) {
  background-color: #f1f1f1;
}
.user-info-container .user-info-table tbody tr:hover {
  background-color: var(--primary-color);
  color: #ffffff;
}
.user-info-container .user-info-table tbody td {
  color: #333;
  font-size: 24px;
}
.user-info-container .user-info-table tbody td.user-info-name {
  display: flex;
  font-size: 24px;
  align-items: center;
}
.user-info-container .user-info-table tbody td.user-info-name img {
  margin-right: 10px;
  width: 24px;
  height: 24px;
}
.user-info-container .user-info-table tfoot tr {
  font-weight: bold;
  background-color: var(--primary-color);
  color: #ffffff;
}
.user-info-container .image {
  width: 24px;
  height: 24px;
}
.user-info-container .user-info-name {
  font-weight: bold;
  text-align: left;
}
@media (max-width: 768px) {
  .user-info-container {
    padding: 10px;
  }
  .user-info-container .user-info-time {
    font-size: 16px;
  }
  .user-info-container .user-info-table th,
  .user-info-container .user-info-table td {
    padding: 4px !important;
    font-size: 12px !important;
  }
  .user-info-container .user-info-table .user-info-name img {
    width: 20px;
    height: 20px;
  }
  .user-info-container .image {
    width: 20px;
    height: 20px;
  }
}
@media (max-width: 480px) {
  .user-info-container {
    padding: 8px;
  }
  .user-info-container .user-info-table th,
  .user-info-container .user-info-table td {
    padding: 6px;
    font-size: 10px;
  }
  .user-info-container .user-info-table .user-info-name img {
    width: 16px;
    height: 16px;
  }
  .user-info-container .image {
    width: 16px;
    height: 16px;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/kpi/userInfo.scss"],"names":[],"mappings":"AAOA;EACE,aAAA;EACA,sBAPiB;EAQjB,mBAAA;EACA,wCAAA;EACA,gCAAA;EACA,cAAA;EACA,YAAA;EACA,gBAAA;EACA,gBAAA;AANF;AAQE;EACE,mBAAA;EACA,eAAA;EACA,WAAA;EACA,iBAAA;AANJ;AAQI;EANF;IAOI,kBAAA;IACA,eAAA;EALJ;AACF;AAQE;EACE,WAAA;EACA,yBAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;AANJ;AAQI;;EAEE,gBAAA;EACA,gBAAA;EACA,yBAAA;EACA,yBAAA;EACA,6CAAA;AANN;AAQM;;EACE,iBAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,gBAAA;AALR;AAOQ;;EACE,sCAtDM;EAuDN,cAAA;AAJV;AASI;EACE,yBAAA;EACA,cAAA;EACA,yBAAA;EACA,eAAA;EACA,gBAAA;EACA,MAAA;EACA,UAAA;AAPN;AAQM;EACE,sCArEQ;EAsER,cAAA;AANR;AASM;EACE,sCA1EQ;EA2ER,cAAA;AAPR;AAaQ;EACE,yBA9EI;AAmEd;AAcQ;EACE,sCAtFM;EAuFN,cAAA;AAZV;AAgBM;EACE,WAAA;EACA,eAAA;AAdR;AAeQ;EACE,aAAA;EACA,eAAA;EACA,mBAAA;AAbV;AAeU;EACE,kBAAA;EACA,WAAA;EACA,YAAA;AAbZ;AAoBM;EACE,iBAAA;EACA,sCA/GQ;EAgHR,cAAA;AAlBR;AAuBE;EACE,WAAA;EACA,YAAA;AArBJ;AAwBE;EACE,iBAAA;EACA,gBAAA;AAtBJ;AAyBE;EAxHF;IAyHI,aAAA;EAtBF;EAwBE;IACE,eAAA;EAtBJ;EA0BI;;IAEE,uBAAA;IACA,0BAAA;EAxBN;EA2BI;IACE,WAAA;IACA,YAAA;EAzBN;EA6BE;IACE,WAAA;IACA,YAAA;EA3BJ;AACF;AA8BE;EAlJF;IAmJI,YAAA;EA3BF;EA8BI;;IAEE,YAAA;IACA,eAAA;EA5BN;EA+BI;IACE,WAAA;IACA,YAAA;EA7BN;EAiCE;IACE,WAAA;IACA,YAAA;EA/BJ;AACF","sourcesContent":["$primary-color: var(--primary-color); // Темный цвет\n$secondary-color: var(--secondary-color); // Светлый цвет\n$background-color: #fff; // Средний цвет\n$border-color: #dcdcdc; // Нейтральный цвет для границ\n$hover-color: #f1f1f1; // Нейтральный цвет для фона строк при наведении\n$highlight-color: $primary-color; // Используем темный цвет для акцентирования\n\n.user-info-container {\n  padding: 20px;\n  background-color: $background-color;\n  border-radius: 12px;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n  font-family: 'Arial', sans-serif;\n  max-width: 90%;\n  margin: auto;\n  margin-top: 15px;\n  overflow-x: auto;\n\n  .user-info-time {\n    margin-bottom: 20px;\n    font-size: 18px;\n    color: #333;\n    text-align: right;\n\n    @media (max-width: 768px) {\n      text-align: center;\n      font-size: 16px;\n    }\n  }\n\n  .user-info-table {\n    width: 100%;\n    border-collapse: collapse;\n    border-radius: 12px;\n    overflow: hidden;\n    table-layout: auto;\n\n    th,\n    td {\n      padding: 4px 6px;\n      text-align: left;\n      border: 1px solid $border-color;\n      background-color: #ffffff;\n      transition: background-color 0.3s, color 0.3s;\n\n      &:first-child {\n        font-weight: bold;\n        cursor: pointer;\n        white-space: nowrap;\n        min-width: 150px; // Минимальная ширина для текста\n        text-overflow: ellipsis;\n        overflow: hidden;\n\n        &:hover {\n          background-color: $primary-color;\n          color: #ffffff; // Белый цвет для текста при выделении\n        }\n      }\n    }\n\n    th {\n      background-color: #e9e9e9;\n      color: #333333; // Черный цвет для текста\n      text-transform: uppercase;\n      font-size: 16px;\n      position: sticky;\n      top: 0;\n      z-index: 1;\n      &:hover {\n        background-color: $primary-color;\n        color: #ffffff; // Белый цвет для текста при выделении\n      }\n\n      &.user-info-selected-column {\n        background-color: $primary-color;\n        color: #ffffff; // Белый цвет для текста при выделении\n      }\n    }\n\n    tbody {\n      tr {\n        &:nth-child(even) {\n          background-color: $hover-color;\n        }\n\n        &:hover {\n          background-color: $highlight-color;\n          color: #ffffff; // Цвет текста при наведении\n        }\n      }\n\n      td {\n        color: #333;\n        font-size: 24px;\n        &.user-info-name {\n          display: flex;\n          font-size: 24px;\n          align-items: center;\n\n          img {\n            margin-right: 10px;\n            width: 24px;\n            height: 24px;\n          }\n        }\n      }\n    }\n\n    tfoot {\n      tr {\n        font-weight: bold;\n        background-color: $highlight-color;\n        color: #ffffff;\n      }\n    }\n  }\n\n  .image {\n    width: 24px;\n    height: 24px;\n  }\n\n  .user-info-name {\n    font-weight: bold;\n    text-align: left;\n  }\n\n  @media (max-width: 768px) {\n    padding: 10px;\n\n    .user-info-time {\n      font-size: 16px;\n    }\n\n    .user-info-table {\n      th,\n      td {\n        padding: 4px !important;\n        font-size: 12px !important;\n      }\n\n      .user-info-name img {\n        width: 20px;\n        height: 20px;\n      }\n    }\n\n    .image {\n      width: 20px;\n      height: 20px;\n    }\n  }\n\n  @media (max-width: 480px) {\n    padding: 8px;\n\n    .user-info-table {\n      th,\n      td {\n        padding: 6px;\n        font-size: 10px;\n      }\n\n      .user-info-name img {\n        width: 16px;\n        height: 16px;\n      }\n    }\n\n    .image {\n      width: 16px;\n      height: 16px;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
